import { Radio, RadioGroup } from '@chakra-ui/react';
import ADF_METHOD from '@constants/add-delivery-fee';
import useOrder from '@hooks/useOrder';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle } from 'react-icons/fa';

export default function AdditionalDeliveryFeeMethod() {
  const { updateOrderInfo } = useOrder();
  const { t } = useTranslation('messageRequest');

  return (
    <section className="flex gap-[6px] flex-col">
      <div>
        <div className="flex items-center justify-center gap-[6px]">
          <span className="font-bold text-lg">
            {t('store:additional_delivery_fee_method')}
          </span>
        </div>
        <div className="text-center text-lg bg-primary-600 flex items-center justify-center gap-2 text-white rounded-lg mt-2 bg-opacity-80 shadow-sm py-1">
          <div>
            <FaExclamationTriangle size="18px" />
          </div>
          <span>{t('store:additional_delivery_fee_description')}</span>
        </div>
      </div>
      <div>
        <RadioGroup
          as="ul"
          colorScheme="red"
          defaultValue=""
          onChange={(value) => updateOrderInfo({ addDeliveryFeeMethod: value })}
        >
          <li>
            <Radio value="" disabled>
              <span className="text-danger-500 text-sm">
                {t('additionalDeliveryDisable')}
              </span>
            </Radio>
          </li>
          {ADF_METHOD.map((msg) => (
            <li key={msg.label}>
              <Radio value={msg.value}>{t(`${msg.label}`)}</Radio>
            </li>
          ))}
        </RadioGroup>
      </div>
    </section>
  );
}
